










































































import { Component, Vue, Watch } from "vue-property-decorator";
import Native from "@/common/Native";
import request from "@/api/yunyang/index";
import {
  Toast,
  Swipe as vanSwipe,
  SwipeItem as vanSwipeItem,
  Image as vanImage
} from "vant";
import {
  IHouseItem,
  IHouseDetailRes,
  ISwiperDetail
} from "@/api/yunyang/types";
import Base from "@/template/public/Base.vue";
import indexRequest from "@/api/index";
import AppPrompt from "@/components/AppPrompt.vue";
import { wxChatShare } from "@/common/wechat";
import { getData, time } from "@/common/dataCollect";
import { findNameByWechatAppid } from "@/common/Utils";
let map: any = null;
@Component({
  components: {
    vanSwipe,
    vanSwipeItem,
    vanImage,
    AppPrompt
  }
})
export default class housedetail extends Base {
  current: number = 0;
  private appId: string = "";
  private id: string = "";
  private isOpenInApp: boolean = false;
  private businessDetail: any = {
    isPraised: "",
    viewCount: "",
    praiseCount: "",
    replyCount: ""
  };
  detail: IHouseItem = {};
  swiperData: Array<ISwiperDetail> = [];
  private userInfo: any = {
    appId: "",
    sessionId: "",
    token: ""
  };
  viewUnit: Array<string> = [
    "",
    "元/㎡",
    "万元/套",
    "元/月",
    "元/季度",
    "元/年"
  ];
  public request: any = new indexRequest();
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  wxAppId = "";
  created() {
    this.startTime = time();
  }
  mounted() {
    document.title = "房屋详情";
    this.appId = (this.$route.query.appId as string) || "";
    this.id = (this.$route.query.id as string) || "";
    this.isOpenInApp = ZWY_CLOUD.isOpenInApp();
    this.getDetail();
    this.getShareInfo(this.appId);
    this.wxAppId = findNameByWechatAppid(this.$store.state.appInfo, this.appId);
    if (this.isOpenInApp) {
      Native.getUserInfo().then((response: any) => {
        this.userInfo = response;
        this.getDetail();
      });

      ZWY_CLOUD.topBarConfig({
        isShowTop: 1,
        isShowBackBtn: 1,
        isShowTitle: "房屋详情",
        isShowMoreBtn: "1"
      });
    } else {
      this.getDetail();
    }
  }
  setWxConfig() {
    wxChatShare(
      this.detail.name,
      this.detail.renovationSituation,
      window.location.href,
      this.swiperData[0].url
    );
  }
  onChange(index: number) {
    this.current = index;
  }

  getDetail() {
    console.log(this.id);
    return request.getHouseDetail(this.id).then((res: IHouseDetailRes) => {
      if (res.code >= 0) {
        this.detail = res.data;
        this.swiperData = res.data.buildingImg;

        this.initialMap();
        this.setWxConfig();
        this.$nextTick(() => {
          // 埋点
          this.endTime = time();
          if (this.dataSource) {
            getData(this.startTime, this.endTime, res.data);
            this.dataSource = false;
          }
        });
      }
    });
  }
  initialMap() {
    map = new BMap.Map("bmap"); // 创建地图实例
    var point = new BMap.Point(this.detail.lng, this.detail.lat); // 创建点坐标
    map.centerAndZoom(point, 15); // 初始化地图，设置中心点坐标和地图级别  地图级别标准到15
    map.enableScrollWheelZoom(true);
  }
  callTel() {
    window.location.href = "tel:" + this.detail.telephone;
  }
  openMap() {
    window.open(
      `http://api.map.baidu.com/marker?location=${this.detail.lat},${this.detail.lng}&title=${this.detail.address}&content=${this.detail.name}&output=html`
    );
  }
}
